import { MessageNotificationService } from './../../services/message-notification.service';
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { PerfilPromptService } from '../../services/bff-prompts-perfil/prompts-perfil.service';
import { MessageService } from 'primeng/api';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { retry, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '../../constants/validation-messages';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.css'],
  providers: [MessageService],
})
export class PerfilComponent implements OnInit, OnDestroy {
  @ViewChild('imagemElemento', { static: false }) imagemElemento!: ElementRef;
  cropper: Cropper | null = null;
  loading: boolean = false;
  public readonly ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  avatarImage: string = 'assets/imagem/default-avatar.png';
  checkAvatar: boolean = false;

  userName: string = '';
  userLogin: string = '';
  userCargo: string = '';
  userFrase: string = '';
  userApelido: string = '';
  userEmail: string = '';
  userOrgao: string = '';
  //userId: number = 0;

  selectedFile: File | null = null;
  isEditing: boolean = false;
  isCropping: boolean = false;

  private originalUserDataForChecks: any = {};
  private destroy$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private perfilPromptService: PerfilPromptService,
    private messageService: MessageService,
    private MessageNotificationService: MessageNotificationService
  ) {}

  ngOnInit(): void {
    if (sessionStorage.getItem('refreshProfilePage') === 'true') {
      sessionStorage.removeItem('refreshProfilePage');
      location.reload();
      return;
    }
    this.loadAndDisplayUserData();
  }

  ngOnDestroy(): void {
    if (this.cropper) {
      this.cropper.destroy();
      this.cropper = null;
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadAndDisplayUserData(): void {
    const userDataFromAuth = this.authService.getUserData();
    this.originalUserDataForChecks = { ...userDataFromAuth };

    if (userDataFromAuth) {
      //this.userId = userDataFromAuth.usuario_id;
      this.userName = userDataFromAuth.usuario_nome || '';
      this.userLogin = userDataFromAuth.usuario_login || '';
      this.userCargo = userDataFromAuth.usuario_cargo || '';
      this.userFrase = userDataFromAuth.usuario_frase || '';
      this.userApelido =
        userDataFromAuth.usuario_apelido || userDataFromAuth.usuario_nome || '';
      this.userEmail = userDataFromAuth.usuario_email || '';
      this.userOrgao = userDataFromAuth.usuario_orgao || '';
      if (userDataFromAuth.usuario_base64_arqfoto) {
        this.avatarImage = `data:image/png;base64,${userDataFromAuth.usuario_base64_arqfoto}`;
      } else if (userDataFromAuth.foto_url) {
        this.avatarImage = userDataFromAuth.foto_url;
      } else {
        this.avatarImage = 'assets/imagem/default-avatar.png';
      }
      this.checkAvatar = false;
    } else {
      this.setDefaultUserDataDisplay();
    }
    this.isEditing = false;
    this.isCropping = false;
    if (this.cropper) {
      this.cropper.destroy();
      this.cropper = null;
    }
    this.selectedFile = null;
  }

  setDefaultUserDataDisplay(): void {
    this.userName = 'Usuário';
    this.userApelido = 'Usuário';
    this.userEmail = 'N/A';
    this.userFrase = '';
    this.userCargo = 'N/A';
    this.avatarImage = 'assets/imagem/default-avatar.png';
    this.userLogin = 'N/A';
    this.checkAvatar = false;
    this.originalUserDataForChecks = {};
  }

  toggleEdit(): void {
    this.isEditing = !this.isEditing;
    if (!this.isEditing && !this.isCropping) {
      this.loadAndDisplayUserData();
    } else if (this.isCropping && !this.isEditing) {
      this.cancelarRecorte();
    }
  }

  onFileSelected(event: Event): void {
    if (!this.isEditing) return;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.avatarImage = reader.result as string;
        this.isCropping = true;
        setTimeout(() => this.iniciarCropper(), 100);
      };
      reader.readAsDataURL(this.selectedFile);
      if (input) input.value = '';
    }
  }

  iniciarCropper(): void {
    if (this.cropper) this.cropper.destroy();
    if (this.imagemElemento?.nativeElement) {
      this.cropper = new Cropper(this.imagemElemento.nativeElement, {
        aspectRatio: 1,
        viewMode: 1,
        autoCropArea: 1,
        scalable: true,
        cropBoxResizable: true,
      });
    } else {
      this.isCropping = false;
      console.error('Elemento para cropper não encontrado.');
    }
  }

  recortarImagem(): void {
    if (!this.cropper) return;
    const canvas = this.cropper.getCroppedCanvas({ width: 300, height: 300 });
    if (!canvas) {
      this.MessageNotificationService.showError(
        ERROR_MESSAGES.AVATAR_CROP_FAILED
      );
      return;
    }
    this.avatarImage = canvas.toDataURL('image/png');
    this.checkAvatar = true;
    this.cropper.destroy();
    this.cropper = null;
    this.isCropping = false;
  }

  cancelarRecorte(): void {
    const userData = this.originalUserDataForChecks;
    if (userData && userData.usuario_base64_arqfoto) {
      this.avatarImage = `data:image/png;base64,${userData.usuario_base64_arqfoto}`;
    } else if (userData && userData.foto_url) {
      this.avatarImage = userData.foto_url;
    } else {
      this.avatarImage = 'assets/imagem/default-avatar.png';
    }
    this.checkAvatar = false;
    this.selectedFile = null;
    if (this.cropper) {
      this.cropper.destroy();
      this.cropper = null;
    }
    this.isCropping = false;
  }

  async onSubmit(): Promise<void> {
    if (!this.isEditing || this.isCropping) {
      return;
    }
    this.startLoading();
    let somethingEffectivelyChanged = false;

    try {
      if (this.checkAvatar) {
        await this.changeUserImageInternal();
        somethingEffectivelyChanged = true;
      }
      const apelidoChanged = !this.checkUserApelido();
      const fraseChanged = !this.checkUserFrase();
      const emailChanged = !this.checkUserEmail();
      if (apelidoChanged || fraseChanged || emailChanged) {
        await this.changeUserTextDataInternal(
          apelidoChanged,
          fraseChanged,
          emailChanged
        );
        somethingEffectivelyChanged = true;
      }
      if (!somethingEffectivelyChanged) {
       this.MessageNotificationService.showInfo(
          ERROR_MESSAGES.PROFILE_NO_CHANGES
        );
        return;
      }
    } catch (error) {
      console.error('Erro no onSubmit do PerfilComponent:', error);
    } finally {
      this.stopLoading();
      this.isEditing = false;
      setTimeout(() => location.reload(), 1000);
    }
  }

  async changeUserImageInternal(): Promise<void> {
    if (!this.userLogin) return Promise.reject('Login não disponível.');
    if (!this.avatarImage.startsWith('data:image/')) return Promise.resolve();
    const blob = await fetch(this.avatarImage).then((res) => res.blob());
    const formData = new FormData();
    formData.append('file', blob, 'avatar.png');
    return new Promise<void>((resolve, reject) => {
      this.perfilPromptService
        .editUserAvatar(this.userLogin, formData)
        .pipe(retry(1), takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            const dataToUpdate = {
              ...(this.authService.getUserData() ||
                this.originalUserDataForChecks),
            };
            dataToUpdate.usuario_base64_arqfoto =
              this.avatarImage.split(',')[1];
            localStorage.setItem('userData', JSON.stringify(dataToUpdate));
            this.authService.syncUserDataFromStorage();
            this.MessageNotificationService.showSuccess(
              SUCCESS_MESSAGES.AVATAR_UPDATED
            );
            this.checkAvatar = false;
            resolve();
          },
          error: (err) => {
            this.MessageNotificationService.showError(
              ERROR_MESSAGES.AVATAR_UPLOAD_FAILED
            );
            this.checkAvatar = false;
            reject(err);
          },
        });
    });
  }

  async changeUserTextDataInternal(
    apelidoChanged: boolean,
    fraseChanged: boolean,
    emailChanged: boolean
  ): Promise<void> {
    //if (!this.userId) return Promise.reject('ID não disponível.');
    const loginParaPayload =
      this.originalUserDataForChecks.usuario_login ===
        (this.originalUserDataForChecks.usuario_apelido ||
          this.originalUserDataForChecks.usuario_nome) && apelidoChanged
        ? this.userApelido
        : this.originalUserDataForChecks.usuario_login;
    return new Promise<void>((resolve, reject) => {
      this.perfilPromptService
        .editUser(
          loginParaPayload,
          this.userEmail,
          this.userApelido,
          this.userFrase
        )
        .pipe(retry(1), takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            const dataToUpdate = {
              ...(this.authService.getUserData() ||
                this.originalUserDataForChecks),
            };
            let detailMsgArray = [];
            if (apelidoChanged) {
              dataToUpdate.usuario_apelido = this.userApelido;
              dataToUpdate.usuario_login = loginParaPayload;
              detailMsgArray.push('Apelido');
            }
            if (fraseChanged) {
              dataToUpdate.usuario_frase = this.userFrase;
              detailMsgArray.push('Frase');
            }
            if (emailChanged) {
              dataToUpdate.usuario_email = this.userEmail;
              detailMsgArray.push('Email');
            }
            localStorage.setItem('userData', JSON.stringify(dataToUpdate));
            this.authService.syncUserDataFromStorage();
            if (detailMsgArray.length > 0)
              this.MessageNotificationService.showSuccess(
                SUCCESS_MESSAGES.PROFILE_UPDATED
              );
            resolve();
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Falha ao atualizar dados.',
            });
            reject(err);
          },
        });
    });
  }

  checkUserFrase(): boolean {
    const novaFrase = (this.userFrase || '').trim();
    const fraseAntiga = (
      this.originalUserDataForChecks.usuario_frase || ''
    ).trim();

    return novaFrase === fraseAntiga;
  }

  checkUserApelido(): boolean {
    const novoApelido = (this.userApelido || '').trim();
    const apelidoAntigo = (
      this.originalUserDataForChecks.usuario_apelido ||
      this.originalUserDataForChecks.usuario_nome ||
      ''
    ).trim();

    return novoApelido === apelidoAntigo;
  }

  checkUserEmail(): boolean {
    const novoEmail = (this.userEmail || '').trim();
    const emailAntigo = (
      this.originalUserDataForChecks.usuario_email || ''
    ).trim();

    return novoEmail === emailAntigo;
  }

  startLoading() {
    this.loading = true;
  }
  stopLoading() {
    this.loading = false;
  }
}
